// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"f22c7fb7","79":"f22c7fb7"}[chunkId] + ".chunk.css";
};